import {FC} from 'react';

import NewServiceRequest from '../../components/ServiceRequests/new';

const NewServiceRequestPage: FC = () => {
  return (
    <div>
      <NewServiceRequest />
    </div>
  );
};

export default NewServiceRequestPage;
